import React from 'react';

import { usePartner_ReturnShippingWidgetQuery } from 'generated/graphql';



export interface IData {
  carrierCode: string;
  trackingNumber: string;
  address: string;
  urlToTrackingPage: string;

  customerName: string;
  street1: string;
  street2: string;
  city: string;
  usState: string;
  postalCode: string;
}

export function useQuery(returnAuthorizationId: string) {
  const tuple = usePartner_ReturnShippingWidgetQuery({
    variables: {
      returnAuthorizationId
    }
  });

  return React.useMemo(
    () => {
      const returnLabel = tuple.data?.returnAuthorization?.shipment;
      const order = tuple.data?.returnAuthorization?.order;
      const data: IData = {
        carrierCode: returnLabel?.carrierCode ?? '',
        address: '',
        trackingNumber: returnLabel?.trackingNumber ?? '',
        urlToTrackingPage: returnLabel?.trackingUrl ?? '',

        customerName: `${order?.customer.firstName} ${order?.customer.lastName}`,
        street1: order?.shippingAddress.street1 ?? '',
        street2: order?.shippingAddress.street2 ?? '',
        city: order?.shippingAddress.city ?? '',
        usState: order?.shippingAddress.usState ?? '',
        postalCode: order?.shippingAddress.postalCode ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
